export const COLLAPSED_NAVBAR = 'collapsedNavbar';
export const EXPANDED_NAVBAR = 'expendedNavbar';
export const RECOMMENDATIONS_PANEL = 'recommendationsPanel';
